"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioIcon = _interopRequireDefault(require("./RadioIcon"));

var _react2 = require("../hooks/react");

var _SingleSelection = _interopRequireDefault(require("../context/SingleSelection"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _core = require("@material-ui/core");

var _excluded = ["dataQa", "children", "disabled", "value", "inputRef"],
    _excluded2 = ["onChange", "name"];

/**
 * Single item in a finite collection of choices under a Radio Group.
 */
var Radio = function Radio(_ref) {
  var dataQa = _ref.dataQa,
      children = _ref.children,
      disabled = _ref.disabled,
      value = _ref.value,
      inputRef = _ref.inputRef,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useContext = (0, _react2.useContext)(_SingleSelection["default"]),
      selected = _useContext.selected,
      onSelect = _useContext.onSelect;

  var _useFormState = (0, _useFormState2["default"])(props),
      stateValue = _useFormState.value,
      name = _useFormState.name,
      _onChange = _useFormState.onChange;

  var isValue = function isValue(val) {
    return val === value;
  };

  var checked = !onSelect ? isValue(stateValue) : isValue(selected);
  var _ = props.onChange,
      __ = props.name,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);

  var icon = /*#__PURE__*/_react["default"].createElement(_RadioIcon["default"], {
    checked: checked
  });

  return /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    label: children,
    disabled: disabled,
    control: /*#__PURE__*/_react["default"].createElement(_core.Radio, (0, _extends2["default"])({
      icon: icon,
      value: value,
      checked: checked,
      checkedIcon: icon,
      color: "primary",
      inputProps: {
        'data-qa': dataQa
      },
      name: name
    }, rest)) // Hidden props
    ,
    name: name,
    inputRef: inputRef // Context based
    ,
    checked: checked,
    onChange: function onChange(event) {
      _onChange && _onChange(event, value);
      onSelect && onSelect(event, value);

      if (window.analytics) {
        window.analytics.track('Radio button click', {
          cta: {
            element: dataQa
          }
        });
      }
    }
  });
};

Radio.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** @ignore */
  name: _propTypes["default"].string,

  /** @ignore */
  selected: _propTypes["default"].any,

  /** The value of the component. */
  value: _propTypes["default"].any,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /** If `true`, the component is disabled. */
  disabled: _propTypes["default"].bool,

  /** @ignore */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /** @ignore */
  onSelect: _propTypes["default"].func
};
Radio.defaultProps = {
  disabled: false
};
var _default = Radio;
exports["default"] = _default;